import { Selector } from 'react-redux';

import { StoreState as AuthStoreState } from '~/components/Auth';
import { StoreState as UserSettingsStoreState } from '~/components/UserSettings';
import { StoreState as AppearanceStoreState } from '~/data/appearance';
import { StoreState as ApplicationConfigStoreState } from '~/data/applicationConfig';
import { StoreState as EntityAttributesStoreState } from '~/data/attributes/slice';
import { StoreState as CompanyDataStoreState } from '~/data/company';
import { StoreState as CompanyPreferencesStoreState } from '~/data/companyPreferences';
import { StoreState as CostCenterStoreState } from '~/data/costCenters';
import { StoreState as CustomTranslationsStoreState } from '~/data/customTranslations';
import { StoreState as EmployeeStoreState } from '~/data/employee';
import { StoreState as EmployeeProfileStoreState } from '~/data/employeeProfile';
import { StoreState as EmployeesStoreState } from '~/data/employees';
import { StoreState as EnumsStoreState } from '~/data/enums';
import { StoreState as LanguageStoreState } from '~/data/languages';
import { StoreState as LegalEntityStoreState } from '~/data/legalEntity';
import { StoreState as OrgUnitsStoreState } from '~/data/orgunits';
import { StoreState as UnitPositionStoreState } from '~/data/unitPositions';
import { StoreState as UserActivityStoreState } from '~/data/userActivity';
import { StoreState as WorkflowConfigStoreState } from '~/data/workflows';
import { StoreState as SWRRequestKeysStoreState } from '~/hooks/useSWR';
import { StoreState as SurveyStoreState } from '~/legacy-components/TopbarSurvey';
import { StoreState as MyWorkspaceStoreState } from '~/scenes/MyWorkspace';

import { StoreState } from './reducer';

export const authStoreStateSelector: Selector<StoreState, AuthStoreState> = (
  state,
) => state.auth;

export const userSettingsStoreStateSelector: Selector<
  StoreState,
  UserSettingsStoreState
> = (state) => state.userSettings;

export const myWorkspaceStoreStateSelector: Selector<
  StoreState,
  MyWorkspaceStoreState
> = (state) => state.myWorkspace;

export const swrStoreStateSelector: Selector<
  StoreState,
  SWRRequestKeysStoreState
> = (state) => state.swr;

export const surveyStoreStateSelector: Selector<
  StoreState,
  SurveyStoreState
> = (state) => state.survey;

export const orgUnitsStoreStateSelector: Selector<
  StoreState,
  OrgUnitsStoreState
> = (state) => state.orgUnits;

export const employeeStateSelector: Selector<StoreState, EmployeeStoreState> = (
  state,
) => state.employee;

export const companyDataStateSelector: Selector<
  StoreState,
  CompanyDataStoreState
> = (state) => state.companyData;

export const companyPreferencesStateSelector: Selector<
  StoreState,
  CompanyPreferencesStoreState
> = (state) => state.companyPreferences;

export const applicationConfigStateSelector: Selector<
  StoreState,
  ApplicationConfigStoreState
> = (state) => state.applicationConfig;

export const employeesStateSelector: Selector<
  StoreState,
  EmployeesStoreState
> = (state) => state.employees;

export const enumsStateSelector: Selector<StoreState, EnumsStoreState> = (
  state,
) => state.enums;

export const costCentersStateSelector: Selector<
  StoreState,
  CostCenterStoreState
> = (state) => state.costCenters;

export const unitPositionsStateSelector: Selector<
  StoreState,
  UnitPositionStoreState
> = (state) => state.unitPositions;

export const employeeProfileStoreStateSelector: Selector<
  StoreState,
  EmployeeProfileStoreState
> = (state) => state.employeeProfile;

export const appearanceStateSelector: Selector<
  StoreState,
  AppearanceStoreState
> = (state) => state.appearance;

export const languagesStateSelector: Selector<
  StoreState,
  LanguageStoreState
> = (state) => state.languages;

export const legalEntityStateSelector: Selector<
  StoreState,
  LegalEntityStoreState
> = (state) => state.legalEntities;

export const workflowConfigStateSelector: Selector<
  StoreState,
  WorkflowConfigStoreState
> = (state) => state.workflow;

export const userActivityStateSelector: Selector<
  StoreState,
  UserActivityStoreState
> = (state) => state.userActivity;

export const customTranslationsStateSelector: Selector<
  StoreState,
  CustomTranslationsStoreState
> = (state) => state.customTranslations;

export const entityAttributesStateSelector: Selector<
  StoreState,
  EntityAttributesStoreState
> = (state) => state.entityAttributes;
